import React, { useEffect, useState } from "react";
import BlogSlider from "../components/common/BlogSlider";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import BlogCard from "../components/common/card/BlogCard";
import BlogSmallCard from "../components/common/card/BlogSmallCard";
import { httpReauest } from "../utils/httpRequest";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../config";
import Loading from "../components/common/Loading";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../hooks/useRouteInfo";

const Blogs = () => {
  const [blogs, setBlogs] = useState();
  const [slider, setslider] = useState();
  const [loading, setloading] = useState();
  const { metaData } = useRouteInfo();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setloading(true);
    await httpReauest("GET", "/blog?oldest=true", {}, {}).then(({ data }) => {
      setBlogs(data?.data);
    });
    await httpReauest("GET", "/blog/slider", {}, {}).then(({ data }) => {
      setslider(data?.data?.blogs);
    });
    setloading(false);
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="py-8 container_1">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <BlogSlider data={slider} />
      <div className="grid grid-cols-3 gap-5">
        <span className="col-span-full grid grid-cols-3 gap-5">
          {blogs?.map((e) => (
            <BlogCard data={e} />
          ))}
        </span>
      </div>
    </div>
  );
};

export default Blogs;
